<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="detail-bg2"></div>
    <div class="guide-box">
      <div class="guide-content">
        <div class="container">
          <div class="tit liner-text">
            <span>{{ $t('add.text61') }}</span>
          </div>
          <div class="step-tit liner-text">
            <span>{{ $t('add.text63') }} 1</span>
          </div>
          <div class="cont">{{ $t('add.text62') }}</div>
          <div class="step-tit liner-text">
            <span>{{ $t('add.text63') }} 2</span>
          </div>
          <div class="cont" v-html="$t('add.text64')"></div>
          <div class="step-tit liner-text">
            <span>{{ $t('add.text63') }} 3</span>
          </div>
          <div class="cont">
            {{ $t('add.text65') }}
          </div>
          <div class="sp">{{ $t('add.text66') }}</div>
          <el-button
            class="el-button--special block sm"
            style="margin-top: 0.2rem"
            @click="handleRoute('/user/mint')"
            >{{ $t('add.text67') }}</el-button
          >
          <el-button
            class="el-button--special3 block sm"
            style="margin-top: 0.2rem"
            @click="handleRoute('/user/nftlist')"
            >{{ $t('add.text68') }}</el-button
          >
          <div class="open-area" style="height: 0.4rem"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UserHowToPlay',
  components: {},
  data() {
    return {}
  },
  methods: {
    handleRoute(path, tabIndex) {
      if (tabIndex) {
        this.$router.push({ path: path, query: { tabIndex: tabIndex } })
      } else {
        this.$router.push({ path: path })
      }
    },
    handleLink(url) {
      window.open(url, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/howtoplay.vue